import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {ACCEPTED_VALET_FILE_TYPES} from '../../../../../../shared/constants/constants';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {CommonMissionService} from '../../../../services/common-mission.service';
import * as moment from 'moment';

@Component({
    selector: 'pv-common-mission-reparations-dialog',
    templateUrl: './common-mission-reparations-dialog.component.html',
    styleUrls: ['./common-mission-reparations-dialog.component.scss'],
    standalone: false
})
export class CommonMissionReparationsDialogComponent implements OnInit {
  public plateNumberLoading = false;

  @Input() entity: any;
  @Input() type: string;
  @Output() submitEvent = new EventEmitter();

  @Input() form: UntypedFormGroup;


  public file: File;
  public FILE_TYPES = ACCEPTED_VALET_FILE_TYPES;
  public allDocs = [];
  public today = moment();

  constructor(private fb: UntypedFormBuilder,
              protected dialogRef: NbDialogRef<CommonMissionReparationsDialogComponent>,
              private commonMissionService: CommonMissionService) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      pictures: this.fb.array([]),
      localisation: [''],
      description: [''],
      plateNumber: [''],
      brand: [''],
      model: [''],
      date: ['']
    });
  }


  submit() {
    const data = this.form.getRawValue();
    data.date = moment(data.date).format('YYYY-MM-DD')
    data.type = this.type;

    const pictures = [];
    const picturesValues = this.form.get('pictures').value;

    for (const picturesValue of picturesValues) {
      if (picturesValue) {
        pictures.push(new File([picturesValue.file], picturesValue.name + '.' + picturesValue.file.name.split('.').pop()));
      }
    }

    this.submitEvent.emit(Object.assign({}, data, {pictures}));
  }

  public plateNumberChanges() {
    if (this.entity.enablePlateNumberSearch) {
      this.plateNumberLoading = true;
      this.commonMissionService.getPlateNumber(this.form.get('plateNumber').value).then(data => {
        this.form.get('brand').setValue(data.brand);
        this.form.get('model').setValue(data.model);
      }).finally(() => {
        this.plateNumberLoading = false;
      });
    }
  }

  public valetUploadMultipleDocuments(event) {
    if (event && event.target && event.target.files) {
      const files = Array.from(event.target.files);
      files.forEach(file => {
        this.addDocumentsInput(file);
      });
      this.updatePictures();
    }
  }

  public addDocumentsInput(value: any) {
    const documentsFormArray = this.form.get('pictures') as UntypedFormArray;
    documentsFormArray.push(
      this.getDocumentInput(value)
    );
  }

  public getDocumentInput(value: any) {
    return this.fb.group({
      file: [value, Validators.required],
      name: [value.name.split('.').slice(0, -1).join('.'), Validators.required]
    });
  }

  private updatePictures() {
    this.allDocs = [];
    this.form.get('pictures').value.forEach(pic => {
      this.allDocs.push({
        name: pic.file ? pic.file.name : pic.name,
        url: pic.file ? URL.createObjectURL(pic.file) : pic.url
      });
    });
  }

  public documentsFormArray() {
    return (this.form.get('pictures') as UntypedFormArray).controls;
  }

  public removeItemFromDocumentsArray(index: number) {
    const arr = this.form.get('pictures') as UntypedFormArray;
    arr.removeAt(index);
    this.updatePictures();
  }
}
